import React, { useContext, useState } from 'react';
import { Button, TagCloud, Tag } from '@agconnections/grow-ui';
import PencilEditIcon from 'components/Icons/components/PencilEditIcon';
import { useFormikContext } from 'formik';
import { SubmissionSummaryContext } from 'screens/Integrations/SubmissionSummary/context/SubmissionSummaryProvider';
import MccainVendorIdModal from './MccainVendorIdModal';

const formatDate = value => {
  if (!value) return '';
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? '' : date.toLocaleDateString();
};

const TopHeader = () => {
  const { values } = useFormikContext();
  const [vendorIdModal, setVendorIdModal] = useState(false);

  const submissionContext = useContext(SubmissionSummaryContext);
  const submissionState = submissionContext?.state;
  const isReadOnly = !!submissionState?.isReadOnly;
  const cwfExtraData = submissionState?.extraData;
  const cwfCropSeasons = submissionState?.cropSeasons;
  const cwfCropSeasonDateRange = submissionState?.cropSeasonDateRange;

  const [initialStartDate, initialEndDate] =
    values?.seasonSingleDateRangeInitial ?? [];

  const mccainVendorId = isReadOnly
    ? cwfExtraData?.mcCainExtraData?.vendorNumber ??
      cwfExtraData?.vendorNumber ??
      values?.mccainVendorId
    : values?.mccainVendorId;

  let cropSeasonsToRender = values?.selectedCropSeasons ?? [];
  if (isReadOnly && cwfCropSeasons?.length) {
    cropSeasonsToRender = cwfCropSeasons;
  }

  const startDate = isReadOnly
    ? cwfCropSeasonDateRange?.[0] ??
      values?.cropSeasonStartDate ??
      initialStartDate
    : values?.cropSeasonStartDate || initialStartDate;
  const endDate = isReadOnly
    ? cwfCropSeasonDateRange?.[1] ?? values?.cropSeasonEndDate ?? initialEndDate
    : values?.cropSeasonEndDate || initialEndDate;

  const showModal = () => {
    setVendorIdModal(true);
  };

  const closeModal = () => {
    setVendorIdModal(false);
  };

  return (
    <div data-testid="top-header">
      {!isReadOnly && (
        <div className="w-full flex h-10 items-center">
          <p className="font-normal text-sm ">
            Review the selected data before submitting to McCain.
          </p>
        </div>
      )}
      <div className="w-full flex h-20 items-center font-semibold">
        <p className="text-2xl">
          McCain Foods Inc. Submission {formatDate(values.submitDate)}
        </p>
      </div>
      <div className="w-full h-32">
        <div className="flex w-full h-full">
          <div className="flex h-full">
            <div className="h-full">
              {!isReadOnly && (
                <MccainVendorIdModal
                  open={vendorIdModal}
                  onClose={closeModal}
                />
              )}
              <p className="font-thin text-xs text-gray-600">
                McCain Vendor ID
              </p>
              <div className="flex w-full items-center">
                <p className="text-2xl pr-2 flex w-auto overflow-x-auto">
                  {mccainVendorId}
                </p>
                {!isReadOnly && (
                  <div className="">
                    <Button
                      type="text"
                      ariaLabel="Edit McCain Vendor ID"
                      icon={<PencilEditIcon />}
                      onClick={showModal}
                    />
                  </div>
                )}
              </div>
            </div>
            <div className="ml-14 h-full">
              <p className="font-thin text-xs text-gray-600">Crop Season(s) </p>
              <div>
                <TagCloud data-testid="crops">
                  {cropSeasonsToRender.map(cropSeason => (
                    <Tag key={cropSeason.id} color="#696F88">
                      {cropSeason.name}
                    </Tag>
                  ))}
                </TagCloud>
              </div>
            </div>
          </div>
          <div className="flex">
            {!isReadOnly && (
              <>
                <div className="flex flex-col ml-14">
                  <p className="font-thin text-xs text-gray-600">Start Date</p>
                  <p className="text-2xl font-normal pr-2">
                    {formatDate(startDate)}
                  </p>
                </div>
                <div className="flex flex-col ml-12">
                  <p className="font-thin text-xs text-gray-600">End Date</p>
                  <p className="text-2xl font-normal pr-2">
                    {formatDate(endDate)}
                  </p>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopHeader;
